import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  startDate: new Date(),
  endDate: new Date(),
  sortBy: "",
  sortOrder: "desc",
  search: "",
  isEdit: false,
  showCreateModal: false,
  showDeleteModal: false,
  clearSelection: false,
  selectedId: "",
  isLoading: false,
  showPassword: false,
  store_name: [],
  payment_mode: [],
  status: [],
  offer: [],
  filterShow: false,
  excelSendModal: false,
  chatShow: false,
  bestSellerExcelSendModal: false,
  mobile:"",
  chatSectionId: "",
  totalOrderCount: "",
  userName: "",
//   totalAmount: "",
//   totalFormattedAmount: "",
//   totalFormattedRedeemedAmount: "",
//   totalFormattedPurchasedAmount: "",
//   totalRedeemedAmount: "",
//   totalPurchasedAmount: "",
//   selectedOrderFilter: "",
};

const aiOrdersSlice = createSlice({
  name: "aiorders",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
    resetConfig: (state) => {
      state.store_name = [];
      state.payment_mode = [];
      state.status = [];
      state.offer = [];
    },
  },
});

export const { updateConfig, resetConfig } = aiOrdersSlice.actions;
export default aiOrdersSlice.reducer;
